var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnsplash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "_2m4hn",
    fill: "#fff",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    "aria-labelledby": titleId,
    "aria-hidden": "false",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "unsplash-home"
  }, "Unsplash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "unsplash-home"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9V0h12v9H10zm12 5h10v18H0V14h10v9h12v-9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsplash);
export default __webpack_public_path__ + "static/media/unsplash.b8ea356010f815378d80c469a39cc2a8.svg";
export { ForwardRef as ReactComponent };